import { useEffect, useState } from 'react';

import { CardMedia, SxProps, Theme } from '@mui/material';

import AvatarIcon from '@/shared/ui/icons/Avatar.webp';
import AvatarManIcon from '@/shared/ui/icons/AvatarMan.webp';
import AvatarWomanIcon from '@/shared/ui/icons/AvatarWoman.webp';

interface IProps {
  photo: string;
  gender?: string | null;
  styles?: SxProps<Theme>;
  /**
   * Подпись картинки. Пустая строка делает изображение декоративным — так
   * заглушка в галерее не объявляется скринридером на каждом кадре
   */
  alt?: string;
  /** Можно ли тащить картинку мышью: в лентах нативный drag-ghost мешает */
  draggable?: boolean;
}

/**
 * Аватар пользователя с заглушками
 * @param root0 - пропсы
 * @param root0.photo - Фото пользователя
 * @param root0.gender - Гендер пользователя
 * @param root0.styles - стили
 * @param root0.alt - подпись картинки
 * @param root0.draggable - можно ли тащить картинку мышью
 */
export const UserAvatarWithPlaceholder = ({
  photo,
  gender,
  styles,
  alt = 'Картинка с аватаркой',
  draggable
}: IProps) => {
  // Фото может не отрисоваться: в старых данных лежат .heic (Chrome их не
  // показывает — новые загрузки конвертируем через heic-to), плюс битые blob'ы.
  // Без фолбэка на месте аватара оставалась иконка сломанной картинки с alt
  const [isPhotoBroken, setIsPhotoBroken] = useState(false);

  useEffect(() => {
    setIsPhotoBroken(false);
  }, [photo]);

  const genderPlaceholder = gender
    ? gender === 'male'
      ? AvatarManIcon
      : AvatarWomanIcon
    : AvatarIcon;

  const avatarImage = photo && !isPhotoBroken ? photo : genderPlaceholder;

  return (
    <CardMedia
      component='img'
      sx={{ height: '100%', width: '100%', objectFit: 'cover', ...styles }}
      image={avatarImage}
      alt={alt}
      draggable={draggable}
      onError={() => setIsPhotoBroken(true)}
    />
  );
};
